import { useState } from 'react';
import { EnhancedButtonStatus } from '@components/button/EnhancedButton';

export const useDrawerSubmission = () => {
  const [submitButtonState, setSubmitButtonState] =
    useState<EnhancedButtonStatus>();
  const [formDisabled, setFormDisabled] = useState(false);

  const handleSubmission = async <T,>(
    submitFunction: () => Promise<T>,
    onSuccess?: (result: T) => void,
    onError?: (error: any) => void
  ): Promise<void> => {
    // Start submission
    setSubmitButtonState('loading');
    setFormDisabled(true);

    try {
      const result = await submitFunction();

      // On success
      setSubmitButtonState('success');
      onSuccess?.(result);
    } catch (error) {
      // On error
      onError?.(error);
    } finally {
      // Reset state
      setTimeout(() => {
        setSubmitButtonState(undefined);
        setFormDisabled(false);
      }, 300);
    }
  };

  return {
    submitButtonState,
    formDisabled,
    handleSubmission
  };
};
